var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper"},[[_c('keep-alive',[_c('router-view')],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }